import { SYS_SPACE_RELATIVE_XL } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const TyreLabelStyle = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_RELATIVE_XL};

	.disclaimer {
		display: flex;
		align-items: center;
		gap: 8px;
		svg {
			min-width: fit-content;
			color: ${({ theme }) => theme.sys.color.text.headline.default};
		}
	}

	.link-text {
		color: ${({ theme }) => theme.sys.color.text.headline.default};
	}
`;

export const ListStyle = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 32px;
`;

export const ListItemStyle = styled.li`
	width: 100%;

	figure {
		display: flex;
		flex-direction: column;
		gap: 12px;

		a {
			align-self: flex-start;
			padding-left: 8px;
		}

		.card {
			width: 100%;
			display: flex;
			justify-content: center;
			padding: 24px;
			height: 200px;

			${breakPoints({
				'768': `width: 320px;`,
			})};
		}
	}

	${breakPoints({
		'768': `width: fit-content;`,
	})};
`;
